import { DEFAULT_ALIGNMENT } from '@/lib/text/constants/text-defaults'

/**
 * Flips a paragraph's horizontal alignment across the spine: left (0) <-> right (2).
 * Center (1) and justify (3) have no direction to flip, so they pass through unchanged.
 */
export function mirrorParagraphAlignment(alignment: number | undefined): number {
  const resolved = alignment ?? DEFAULT_ALIGNMENT

  if (resolved === 0) return 2
  if (resolved === 2) return 0

  return resolved
}
